import { BaseMdl } from './BaseMdl';

export class batteryDataMdl {
    machine_id: number = 0;
    machine_name: string = '';
    latitude: number = 0;
    longitude: number = 0;
    battery_level: number = 0;
    acquisition_time: string = '';
    threshold_low: number = 0;
    threshold_high: number = 0;
    control_number: string = '';
    signalstrength: number = 0;
    lot_number: string = '';
    remark: string = '';
    office_name: string = '';

    constructor(init?: Partial<batteryDataMdl>) {
        Object.assign(this, init);
    }

    public static toJsonDataOnModel(data: any): any {
        return BaseMdl.toJsonOnModel(new batteryDataMdl(), data);
    }
}
